import React, { Component } from "react";
import { Redirect, withRouter } from "react-router-dom";
import compose from "recompose/compose";
import DashBlock from "./../../components/DashBlock";
import CustomTable from "./../../components/CustomTable";
import {
  Row,
  Col,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Input,
  FormGroup,
} from "reactstrap";

// import gapanapa_wgs from '../../assets/geoJson/gapanapa_wgs';
import CircularProgressbar from "react-circular-progressbar";
// import provinceJson from '../../assets/geoJson/province';
import "react-circular-progressbar/dist/styles.css";
import { changeIndexToNepali, colorScale } from "../../utils";
import Api from "../../services/api";
import "./style.css";
import ProgressBar from "../../components/ProgressBar";
import provinceMapJson from "../../assets/geoJson/province.json";
import localMapJson from "../../assets/geoJson/local.json";
import DashboardFinal from "../MinistryDashboard/dashboard/index";
import {
  Radar,
  Legend,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  ResponsiveContainer,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Bar,
} from "recharts";
import { BounceLoader } from "react-spinners";

import NonMinistryAccordion from "../../components/accordion/nonministry";
class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        categories: [],
      },
      activeTab: "local",
      orgData: null,
      provinceMap: null,
      localMap: null,
      nepalData: null,
      provinceData: null,
      localData: null,
      activeData: null,
      categories: [],
      subCategories: [],
      totalLgFilled: 0,
      isLoading: true,
      checkData: [],
      catData: [],
      topData: [],
      latestData: [],
      summary: [],
      fy: null,
      fyId: 0,
      fyList: [],
      provinceId: 0,
      provinceList: [],
      districtId: 0,
      districtList: [],
      palikaId: 0,
      palikaList: [],
      isDataLoading: false,
      ministryLevel: false,
      ministryCat: [],
      activeTabMinistry: 0,
    };

    this.loadMap = this.loadMap.bind(this);
    this.toggle = this.toggle.bind(this);
    this._updateData = this._updateData.bind(this);
    this._getCategories = this._getCategories.bind(this);
    // this._getNepalProvinceData = this._getNepalProvinceData.bind(this);
    // this._getLocalData = this._getLocalData.bind(this);
    this._redirect = this._redirect.bind(this);
    this._setColor = this._setColor.bind(this);
    this._onChangeProv = this._onChangeProv.bind(this);
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }
  _getProvinceData = async () => {
    const prov = await Api.getProvinceMap(this.state.fyId);
    this.setState({ province: prov.response });
  };

  _getDistrict = async () => {
    const dis = await Api.getDistrict(this.state.province);
    this.setState({ district: dis.response });
  };

  async componentDidMount() {
    let fiscal;
    this.setState({
      provinceId: sessionStorage.getItem("provinceId")
        ? sessionStorage.getItem("provinceId")
        : 1,
    });
    if (localStorage.getItem("user")) {
      fiscal = JSON.parse(localStorage.getItem("user")).user.fiscal_year_id;
    }
    await this.setState({
      fyId: fiscal ? fiscal : localStorage.getItem("fiscalYear"),
    });

    this._getCategories();
    this._getHomeData();
    this._getFiscalyear();
    this._getProvinceList();
    this._getProvinceData();
    this.loadMap();
  }

  async _getCategories() {
    let catRes = await Api.getCategories();
    let subCatRes = await Api.getSubCategories();
    this.setState({
      categories: catRes.response,
      subCategories: subCatRes.response,
    });
  }

  _getHomeData = async () => {
    this.setState({
      isLoading: true,
    });
    let homeRes = await Api.getHomeData({
      fiscal_year_id: this.state.fyId,
      province_id: this.state.provinceId,
    });
    let homeRes1 = await Api.getMinistryHomeData({
      fiscal_year_id: this.state.fyId,
      province_id: this.state.provinceId,
    });
    let nullData = {
      name: "",
      score: "-",
      totalMarks: 0,
      mainCategories: [],
      categories: {
        1: "0",
        2: "0",
        3: "0",
        4: "0",
        5: "0",
        6: "0",
        7: "0",
        8: "0",
        9: "0",
        10: "0",
      },
      subCategories: {
        1: "0",
        2: "0",
        3: "0",
      },
    };

    console.log("Home Data", homeRes);

    if (homeRes.response.categories) {
      let maxCategory = null;

      let maxTotalMarks = -1;

      for (const category of homeRes.response.categories) {
        if (parseFloat(category.total_marks) > maxTotalMarks) {
          maxTotalMarks = parseFloat(category.total_marks);
          maxCategory = category;
        }
      }
      this.setState({
        maxvalue: maxTotalMarks,
      });
    }

    this.setState({
      nepalData: homeRes.response.nepal,
      provinceData: homeRes.response.province,
      localData: homeRes.response.lg,
      activeData: homeRes.response.nepal,
      nullData,
      isLoading: false,
      checkData: homeRes.response.stat,
      catData: homeRes.response.categories,
      topData: homeRes.response.top_ministry,
      latestData: homeRes.response.least_palikas,
      summary: homeRes.response.evaluation_summary,
      ministryCat: homeRes1.response.questions,
    });
  };

  _getHomeDataFilter = async (params) => {
    this.setState({
      isLoading: true,
    });
    let homeRes = await Api.getHomeData(params);
    let homeRes1 = await Api.getMinistryHomeData({
      fiscal_year_id: localStorage.getItem("fiscalYear"),
      province_id: sessionStorage.getItem("provinceId"),
    });
    let nullData = {
      name: "",
      score: "-",
      totalMarks: 0,
      categories: {
        "1": "0",
        "2": "0",
        "3": "0",
        "4": "0",
        "5": "0",
        "6": "0",
        "7": "0",
        "8": "0",
        "9": "0",
        "10": "0",
      },
      subCategories: {
        "1": "0",
        "2": "0",
        "3": "0",
      },
    };
    this.setState({
      nepalData: homeRes.response.nepal,
      provinceData: homeRes.response.province,
      localData: homeRes.response.lg,
      activeData: homeRes.response.nepal,
      nullData,
      isLoading: false,
      checkData: homeRes.response.stat,
      catData: homeRes.response.categories,
      topData: homeRes.response.top_ministry,
      latestData: homeRes.response.least_palikas,
      summary: homeRes.response.evaluation_summary,
      ministryCat: homeRes1.response.questions,
    });
  };

  _getFiscalyear = async () => {
    let fyList = await Api.getFyList();
    this.setState({ fyList: fyList.response });
  };

  _handleFiscalYearChange = async (e) => {
    let fiscalYearId = e.target.value;
    this.setState({
      fyId: fiscalYearId,
      provinceId: 0,
      districtId: 0,
      districtList: [],
      palikaId: 0,
      palikaList: [],
      isDataLoading: true,
    });
    localStorage.setItem("fiscalYear", fiscalYearId);
    await this._getHomeDataFilter({
      fiscal_year_id: fiscalYearId,
      province_id: sessionStorage.getItem("provinceId"),
    });
    this.setState({
      isDataLoading: false,
    });
  };

  _getProvinceList = async () => {
    let provinceListRes = await Api.getProvinceList();

    this.setState({
      provinceList: provinceListRes.response,
    });
  };

  _handleProvinceChange = async (e) => {
    let provinceId = e.target.value;
    this.setState({
      provinceId: provinceId,
      districtId: 0,
      palikaId: 0,
      palikaList: [],
      isDataLoading: true,
    });
    await this._getDistrictList(provinceId);
    await this._getHomeDataFilter({
      province_id: provinceId,
      fiscal_year_id: this.state.fyId,
    });
    this.setState({
      isDataLoading: false,
    });
  };
  _updateData(objectId, type, layerName) {
    const { provinceData, localData, nepalData, nullData } = this.state;
    let data;
    switch (type) {
      case "province":
        let provinceFound = provinceData.find((p) => p.name == objectId);
        if (provinceFound) {
          data = provinceFound;
        } else {
          data = nullData;
          data.name = layerName;
        }
        this.setState({ activeData: data });
        return;
      case "local":
        let lgFound = localData.find((lg) => lg.gnid == objectId);
        if (lgFound) {
          data = lgFound;
        } else {
          data = nullData;
          data.name = layerName;
        }
        this.setState({ activeData: data });
        return;
      default:
        this.setState({ activeData: nepalData });
        return;
    }
  }

  _redirect(objectId, type) {
    const { history } = this.props;
    const { localData, provinceData } = this.state;
    let lgFound = localData.find((lg) => lg.gnid === objectId);

    if (type === "local" && !lgFound) {
      return;
    } else if (type === "province") {
      return;
    }
    history.push({
      pathname: `/details/${type}/${objectId}`,
    });
  }

  loadMap() {
    // let localMap = await Api.getMap({type:'local'});
    let provinceMapRes = provinceMapJson;
    let provinceMapGeo = {
      type: "FeatureCollection",
      features: [],
    };
    provinceMapRes.response.map((province) => {
      provinceMapGeo.features.push({
        type: "Feature",
        geometry: province.geometry,
        properties: {
          province: province.name,
        },
      });
    });

    // this.setState({ provinceMap: provinceMapGeo });
    let lgMapRes = localMapJson;
    let lgMapGeo = {
      type: "FeatureCollection",
      features: [],
    };
    lgMapRes.response.map((lg) => {
      lgMapGeo.features.push({
        type: "Feature",
        geometry: lg.geometry,
        properties: {
          gnid: lg.gnid,
          palika: lg.name,
        },
      });
    });
    this.setState({ localMap: lgMapGeo, provinceMap: provinceMapGeo });
  }

  _onLoginClick() {
    return (
      <Redirect
        to={{
          pathname: "/login",
          state: { from: this.props.location },
        }}
      />
    );
  }

  _renderCategoriesList() {
    const { categories } = this.state;
    console.log("first catego", this.state.catData);

    return (
      this.state &&
      this.state.catData &&
      this.state.catData.map((category, catIndex) => {
        let style = {
          witdh: changeIndexToNepali(category.score) + "%",
          backgroundColor: colorScale(category.score),
        };
        const isImage = category.image.match(/\.(jpeg|jpg|gif|png)$/) !== null;
        return (
          <div className="main-list" key={catIndex}>
            <span className="dash-cat-name">
              <img
                // src={
                //   isImage
                //     ? category.image
                //     : require(`../../assets/images/${catIndex + 1}.svg`)
                // }
                src={ category.image }
                className="cat-icon"
                alt="cat-icon"
              />
              {category.name}
            </span>
            {/* <span className='dash-cat-rank'>{changeIndexToNepali(category.rank)}</span> */}
            <ProgressBar
              bgcolor={colorScale(category.score)}
              progress={category.score}
              height={10}
            />
          </div>
        );
      })
    );
  }

  _setColor(objectId, type) {
    const { provinceData, localData } = this.state;
    switch (type) {
      case "province":
        let provinceFound = provinceData.find((p) => p.name == objectId);
        if (provinceFound) {
          return colorScale(provinceFound.percentage);
        }
        break;
      case "local":
        let lgFound = localData.find((lg) => lg.gnid == objectId);
        if (lgFound) {
          return colorScale(lgFound.percentage); //TODO score to peercent
        }
        break;
      default:
        break;
    }
    return "#bebebe";
  }
  _onChangeProv = (event) => {
    this.setState({ provId: event.target.value });
  };

  _renderSubCategories() {
    let content = [];
    const { subCategories, activeData } = this.state;
    if (!activeData) return;
    subCategories.map((subCategory) => {
      let scatId = subCategory.id.toString();
      content.push(
        <div className="pro" key={scatId}>
          <CircularProgressbar
            percentage={activeData.subCategories[scatId]}
            text={`${changeIndexToNepali(
              activeData.subCategories[scatId] || "-"
            )}`}
            styles={{
              path: { stroke: colorScale(activeData.subCategories[scatId]) },
              text: { fill: "#66d120", fontSize: "26px" },
            }}
          />
          <p>{subCategory.name}</p>
        </div>
      );
    });
    return content;
  }

  getEvaluationSummary = (summary) => {
    let sum = [];
    let first = 0;

    for (let i = 0; i < summary.length; i++) {
      sum.push(summary[i][1]);
    }
    for (let i = 0; i < sum.length; i++) {
      first += sum[i];
    }

    let sum2 = [];
    let first2 = 0;

    for (let i = 0; i < summary.length; i++) {
      sum2.push(summary[i][2]);
    }
    for (let i = 0; i < sum2.length; i++) {
      first2 += sum2[i];
    }

    let sum3 = [];
    let first3 = 0;

    for (let i = 0; i < summary.length; i++) {
      sum3.push(summary[i][3]);
    }
    for (let i = 0; i < sum3.length; i++) {
      first3 += sum3[i];
    }

    let sum4 = [];
    let first4 = 0;

    for (let i = 0; i < summary.length; i++) {
      sum4.push(summary[i][4]);
    }
    for (let i = 0; i < sum4.length; i++) {
      first4 += sum4[i];
    }

    let sum5 = [];
    let first5 = 0;

    for (let i = 0; i < summary.length; i++) {
      sum5.push(summary[i][5]);
    }
    for (let i = 0; i < sum5.length; i++) {
      first5 += sum5[i];
    }

    let sumData = ["कुल जम्मा"];
    sumData.push(first, first2, first3, first4, first5);
    let summaryModified = summary;
    summaryModified.push(sumData);
    return summaryModified;
  };

  render() {
    const { history } = this.props;
    const { isLoading, fyId, fyList } = this.state;

    class BarLabel extends Component {
      render() {
        const { x, y, fill, value } = this.props;
        return (
          <text
            x={x}
            y={y}
            dy={-5}
            dx={20}
            fontSize="16"
            fontFamily="sans-serif"
            fill={"#046204"}
            textAnchor="right"
          >
            {value}
          </text>
        );
      }
    }

    const options = {
      responsive: true,
      plugins: {
        legend: {
          position: "top",
        },
        title: {
          display: true,
          text: "Chart.js Bar Chart",
        },
        datalabels: {
          align: "end", // Adjust the position of the data labels
          anchor: "end",
          display: "auto", // Display labels automatically
        },
      },
    };

    return (
      <>
        {!this.state.ministryLevel && (
          <>
            {isLoading ? (
              <div className="w-100 d-flex justify-content-center my-5">
                {" "}
                <BounceLoader color="#1f8cd5" />
              </div>
            ) : (
              <section className="home detail">
                <Row className={"align-items-center"}>
                  <Col>
                    <div className="home-title">
                      <span className="">PFRA |</span>
                      <span
                        className=""
                        style={{
                          fontSize: "18px",
                          fontWeight: "bold",
                          color: "black",
                          marginLeft: "5px",
                        }}
                      >
                        Home
                      </span>
                    </div>
                  </Col>
                  <div className="switchcontent1">
                    <p
                      className={
                        this.state.ministryLevel
                          ? "m-0 p-2 activecontent3"
                          : "m-0 p-2"
                      }
                      style={{
                        borderRight: "1px solid #b3b1b1",
                        cursor: "pointer",
                      }}
                      onClick={() => this.setState({ ministryLevel: true })}
                    >
                      एकीकृत
                    </p>
                    <p
                      className={
                        this.state.ministryLevel
                          ? "m-0  p-2"
                          : "m-0 p-2 activecontent4"
                      }
                      style={{ cursor: "pointer" }}
                      onClick={() => this.setState({ ministryLevel: false })}
                    >
                      मन्त्रालय
                    </p>
                  </div>

                  <Col sm={2}>
                    <FormGroup>
                      <Input
                        type="select"
                        name="fselect"
                        id="fiscalYearSelect"
                        value={fyId}
                        onChange={(e) => this._handleFiscalYearChange(e)}
                      >
                        <option
                          value={0}
                          disabled
                          selected
                          style={{ cursor: "pointer" }}
                        >
                          आर्थिक वर्ष चयन गार्नुहोस
                        </option>
                        {fyList.length > 0 &&
                          fyList.map((fy, index) => {
                            return (
                              <option key={fy.id} value={fy.id}>
                                आर्थिक वर्ष {fy.name}
                              </option>
                            );
                          })}
                      </Input>
                    </FormGroup>
                  </Col>
                </Row>
                {this.state.isDataLoading ? (
                  <div className="w-100 d-flex justify-content-center my-5">
                    {" "}
                    <BounceLoader color="#1f8cd5" />
                  </div>
                ) : (
                  <>
                    {!this.state.ministryLevel && (
                      <DashBlock data={this.state.checkData} />
                    )}
                    {!this.state.ministryLevel && (
                      <div className="chart-section">
                        <Row>
                          <Col sm="4" className="">
                            <div className="cat-list card-layout h-100">
                              <h3 className="sub-heading">
                                मूल्याङ्कनका विषयक्षेत्रहरु{" "}
                              </h3>
                              <div className="main-list">
                                <span className="dash-cat-name-title"></span>
                                {/* <span className='dash-cat-rank-title'>बरीयतक्रम</span> */}
                                <span className="dash-cat-score-title">
                 
                                </span>
                              </div>
                              {this._renderCategoriesList()}
                            </div>
                          </Col>
                          <Col sm="8">
                            <div className="card-layout">
                              <h3 className="sub-heading d-flex justify-content-center text-center m-0">
                                मूल्याङ्कनका विषयक्षेत्रहरु{" "}
                              </h3>
                              <RadarChart
                                outerRadius={150}
                                width={600}
                                height={400}
                                data={this.state.catData}
                              >
                                <PolarGrid />
                                <PolarAngleAxis dataKey="name" />
                                <PolarRadiusAxis angle={90} domain={[0, 100]} />
                                <Radar
                                  name="औसत"
                                  dataKey="score"
                                  stroke="#8884D8"
                                  fill="#8884D8"
                                  fillOpacity={0.6}
                                />
                                <Radar
                                  name="पूर्णांङ्क"
                                  stroke="#82ca9d"
                                  strokeWidth="3"
                                  fill="#82ca9d"
                                  dataKey="total_percentage"
                                  fillOpacity={0}
                                />
                                <Legend />
                              </RadarChart>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    )}
                    {/* <div className="chart-section">
                  <SummaryTable title={'मूल्यांकनको सारांश'} comments={this.state.summary.length > 0 ? this.getEvaluationSummary(this.state.summary) : this.state.summary} />
                </div> */}

                    {/* ministry_level charts */}
                    {!this.state.ministryLevel && (
                      <div className="d-flex my-4">
                        <div className="col-4  mr-4 p-0">
                          <Nav
                            vertical
                            style={{ border: "none", margin: "none" }}
                            className="bg-white pr-1 rounded shadow-sm"
                          >
                            <p className="sub-heading mx-3 mt-3">
                              मन्त्रालयगत वित्तीय सुशासन लेखाजोखा मूल्याङ्क
                            </p>
                            {this.state.ministryCat &&
                              this.state.ministryCat.map((tabData, index) => (
                                <NavItem
                                  key={index}
                                  style={{ width: "100%", display: "flex" }}
                                  onClick={() => {
                                    this.setState({ activeTabMinistry: index });
                                  }}
                                >
                                  <NavLink
                                    className={`${
                                      this.state.activeTabMinistry === index
                                        ? "nav-link-purple-borde px-4"
                                        : "nav-link-ordinar px-3"
                                    }`}
                                  >
                                    {tabData && tabData.name}
                                  </NavLink>
                                  {this.state.activeTabMinistry === index && (
                                    <div className="arrow-right" />
                                  )}
                                </NavItem>
                              ))}
                          </Nav>
                        </div>
                        <div className="col ml-2">
                          <TabContent activeTab={this.state.activeTabMinistry}>
                            {this.state.ministryCat &&
                              this.state.ministryCat.map((tabData, index) => (
                                <TabPane key={index} tabId={index}>
                                  {console.log(
                                    "tabData",
                                    tabData.subcategories
                                  )}
                                  <div className="d-flex align-items-center">
                                    <div className="d-flex flex-wrap justify-content-around col-8 bg-white rounded shadow-sm p-3">
                                      <ResponsiveContainer
                                        ResponsiveContainer
                                        width="100%"
                                        height={325}
                                      >
                                        <BarChart
                                          data={tabData.subcategories}
                                          height={325}
                                        >
                                          <CartesianGrid />
                                          <XAxis dataKey="name" />
                                          <YAxis
                                            // domain={[0, 30]}
                                            domain={[0, "dataMax + 10"]}
                                          />
                                          <Tooltip position={{ x: 0, y: 0 }} />
                                          <Legend />
                                          <Bar
                                            dataKey="marks"
                                            fill="#8884d8"
                                            name="औसत"
                                            label={<BarLabel />}
                                          />
                                          <Bar
                                            dataKey="total_marks"
                                            fill="#82ca9d"
                                            name="पूर्णांङ्क"
                                            label={<BarLabel />}
                                          />
                                        </BarChart>
                                      </ResponsiveContainer>
                                    </div>
                                    <div
                                      className="col-4 pt-4 ml-3 bg-white rounded shadow-sm align-self-center"
                                      style={{ height: "350px" }}
                                    >
                                      <p
                                        className="text-center h4"
                                        style={{
                                          textDecoration: "underline",
                                          color: "#2571BB",
                                        }}
                                      >
                                        अंकतालिका
                                      </p>
                                      <div
                                        className=" card shadow-sm p-2 col-12 d-flex bg-light"
                                        style={{ height: "100px" }}
                                      >
                                        <p className="text-success h5 text-center">
                                          कुल औसत
                                        </p>
                                        <p
                                          className="text-center h4"
                                          style={{ color: "#FF7D00" }}
                                        >
                                          {changeIndexToNepali(
                                            tabData.obtained_marks
                                          )}
                                        </p>
                                      </div>

                                      <div
                                        className="card shadow-sm p-2 col-12 d-flex bg-light "
                                        style={{ height: "100px" }}
                                      >
                                        <p className="text-success h5 text-center">
                                          कुल पूर्णांङ्क
                                        </p>
                                        <p
                                          className="text-center h4"
                                          style={{ color: "#FF7D00" }}
                                        >
                                          {changeIndexToNepali(
                                            tabData.total_marks
                                          )}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </TabPane>
                                // <Bar
                                //   options={options}
                                //   data={tabData.subcategories}
                                // />
                              ))}
                          </TabContent>
                        </div>
                      </div>
                    )}

                    {console.log("bina",this.state.ministryLevel)}

                    {!this.state.ministryLevel && (
                      <div className="chart-section">
                        <CustomTable
                        ministryLevel = {!this.state.ministryLevel}
                          categories={this.state.catData}
                          title={"अधिकतम नतिजा प्राप्त गर्ने "}
                          comments={this.state.topData}
                        />
                      </div>
                    )}
                  </>
                )}
              </section>
            )}
          </>
        )}{" "}
        {this.state.ministryLevel && (
          <DashboardFinal
            ministryLevel={this.state.ministryLevel}
            handleMinistrylevel={(value) =>
              this.setState({ ministryLevel: value })
            }
          />
        )}{" "}
      </>
    );
  }
}

const enhance = compose(withRouter);

export default enhance(Home);
